import { Map, Popup } from 'leaflet';
import React from 'react';

const usePopup = (map: Map | null) => {
  const [popup, setPopup] = React.useState<Popup | null>(null);

  React.useEffect(() => {
    map?.on('popupopen', (e) => {
      setPopup(e.popup);
    });

    map?.on('popupclose', () => {
      setPopup(null);
    });
  }, [map]);

  return popup;
};

export default usePopup;
